import Badge from '@assets/icons/badge.svg?react';
import { usePublicEventContext } from '@event/contexts/PublicEventContext';
import { formatISODurationToFullString, getEventRequiredBadges } from '@event/utils/event';
import { DefaultBadge } from '@levelSystem/components/badges';
import { Tooltip, Typography } from '@mui/material';
import { capitalizeFirstLetter } from '@utils/common';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

const EventDetailCardBadges = () => {
    const {
        event: { data: event },
    } = usePublicEventContext();

    const requiredBadges = useMemo(
        () => (event?.level_badge_requirements ? getEventRequiredBadges(event.level_badge_requirements) : []),
        [event?.level_badge_requirements]
    );

    return requiredBadges.length > 0 ? (
        <div className="px-3.5 md:px-0 mb-5">
            <div className="flex flex-col gap-5">
                <div className="flex justify-between w-full">
                    <div className="flex items-center gap-2">
                        <Badge />
                        <Typography color="neutral-900.main" fontWeight={700}>
                            <FormattedMessage id="event.badge.required" defaultMessage="REQUIRED BADGES" />
                        </Typography>
                    </div>
                    <div className="grid grid-cols-5 gap-1 direction-rtl" dir="rtl">
                        {requiredBadges.map((badge) => (
                            <Tooltip
                                key={badge.id}
                                title={`${capitalizeFirstLetter(
                                    badge.level_badge.badge.name
                                )} | ${capitalizeFirstLetter(badge.level_badge.level.name)}${
                                    badge.timeframe ? ` | ${formatISODurationToFullString(badge.timeframe)}` : ''
                                }`}
                                arrow
                            >
                                <div>
                                    {badge.level_badge.image ? (
                                        <img className="size-8" src={badge.level_badge.image} />
                                    ) : (
                                        <DefaultBadge level={badge.level_badge.level.value} />
                                    )}
                                </div>
                            </Tooltip>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    ) : null;
};

export { EventDetailCardBadges };
